"use client";
import { useEffect } from "react";
import { captureAttribution } from "@/libs/aiChannel";
/** İlk toxunuş AI-kanal atribusiyası — səhifə yüklənəndə bir dəfə cookie yazır (agentic commerce, 2026-09-12). */
export default function AttributionCapture() {
  useEffect(() => { try { captureAttribution(); } catch { /* cookie bloklana bilər */ } }, []);
  return null;
}
